<template>
    <tr>
      <td data-label="Reference #">
        <router-link :to="{ path: '/approvedQuotes?report=' + quote.uuid }" >
          <strong>
            {{ quote.reference }}
          </strong>
        </router-link>
      </td>
      <td data-label="Property Address">
        {{ quote.address }}
      </td>
      <td data-label="Quote Type">
        {{ quote.QuoteType.quoteName }}
      </td>
      <td data-label="Requested">
        {{ quote.Customer.dropdownLabel }} <br/>
        <span class="text-muted">{{ dateRequested }}</span>
      </td>
      <td data-label="Live Feed">
        <router-link :to="{ path: '/liveFeed?QuoteUuid=' + quote.uuid }" >
          Live Feed
        </router-link>
      </td>
      <td data-label="Assigned Date">
        <span class="text-muted">{{ dateAssigned }}</span>
      </td>
    </tr>

</template>

<script>
  export default {
    name: 'ApprovedQuoteRow',
    props: {
      object: {
        type: Object
      }
    },
    computed: {
      formData () {
        return JSON.stringify({ quoteUuid: this.quote.uuid })
      },
      dateRequested () {
        return moment(this.quote.createdAt).format('dddd Do of MMMM YYYY hh:mm A')
      },
      quote () {
        return {
          ...this.object
        }
      },
      dateAssigned () {
        return this.quote.ActionLogs.length !== 0 ? moment(this.quote.ActionLogs[0].createdAt).format('dddd Do of MMMM YYYY hh:mm A') : 'N/A'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/rows/AssignedQuoteRow.vue